module.exports = __webpack_public_path__ + "img/form_banner.bc55f994.jpg";